import React, { useState } from "react";
import MasterButton, { ButtonLayoutType, ButtonSize, ButtonVariation } from "../button/MasterButton";
import "./ButtonGroup.css";

type ButtonGroupProps = {
  buttons: {
    label: string;
    icon: string | JSX.Element;
    layoutType: ButtonLayoutType;
    size: ButtonSize;
    variation: ButtonVariation;
    onClick: () => void;
    className?: string;
    disabled?: boolean;
  }[];
  groupClassName?: string;
};

const ButtonGroup: React.FC<ButtonGroupProps> = ({ buttons, groupClassName }) => {
  const [selectedIndex, setSelectedIndex] = useState<number | null>(null);

  const handleButtonClick = (index: number, onClick: () => void) => {
    setSelectedIndex(index);
    onClick(); // Trigger the button's onClick action
  };

  return (
    <div className={`button-group ${groupClassName}`}>
      {buttons.map((button, index) => (
        <MasterButton
          key={index}
          options={{
            layoutType: button.layoutType,
            size: button.size,
            variation: button.variation,
            label: button.label,
            icon: button.icon,
            className: `${button.className}`,
          }}
          disabled={button.disabled}
          onClick={() => {
            handleButtonClick(index, button.onClick); // Wrap the onClick handler
          }}
        />
      ))}
    </div>
  );
};

export default ButtonGroup;
